import _defineProperty from "/runner/_work/instore-core/instore-core/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/runner/_work/instore-core/instore-core/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import $5a023$react, { useContext as $5a023$useContext, useState as $5a023$useState, useEffect as $5a023$useEffect, useMemo as $5a023$useMemo, useCallback as $5a023$useCallback, useRef as $5a023$useRef } from "react";
import { useIsSSR as $5a023$useIsSSR } from "@react-aria/ssr";
import { MessageDictionary as $5a023$MessageDictionary, MessageFormatter as $5a023$MessageFormatter } from "@internationalized/message";
import { DateFormatter as $5a023$DateFormatter } from "@internationalized/date";
import { NumberFormatter as $5a023$NumberFormatter } from "@internationalized/number";

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {
    get: v,
    set: s,
    enumerable: true,
    configurable: true
  });
}

var $21755e9e87423be2$exports = {};
$parcel$export($21755e9e87423be2$exports, "I18nProvider", function () {
  return $21755e9e87423be2$export$a54013f0d02a8f82;
});
$parcel$export($21755e9e87423be2$exports, "useLocale", function () {
  return $21755e9e87423be2$export$43bb16f9c6d9e3f7;
});
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */
// https://en.wikipedia.org/wiki/Right-to-left

var $4cf919b2fb2672be$var$RTL_SCRIPTS = new Set(['Arab', 'Syrc', 'Samr', 'Mand', 'Thaa', 'Mend', 'Nkoo', 'Adlm', 'Rohg', 'Hebr']);
var $4cf919b2fb2672be$var$RTL_LANGS = new Set(['ae', 'ar', 'arc', 'bcc', 'bqi', 'ckb', 'dv', 'fa', 'glk', 'he', 'ku', 'mzn', 'nqo', 'pnb', 'ps', 'sd', 'ug', 'ur', 'yi']);

function $4cf919b2fb2672be$export$702d680b21cbd764(locale) {
  // If the Intl.Locale API is available, use it to get the script for the locale.
  // This is more accurate than guessing by language, since languages can be written in multiple scripts.
  // @ts-ignore
  if (Intl.Locale) {
    // @ts-ignore
    var script = new Intl.Locale(locale).maximize().script;
    return $4cf919b2fb2672be$var$RTL_SCRIPTS.has(script);
  } // If not, just guess by the language (first part of the locale)


  var lang = locale.split('-')[0];
  return $4cf919b2fb2672be$var$RTL_LANGS.has(lang);
}

function $916d1fd2754d3f8c$export$f09106e7c6677ec5() {
  // @ts-ignore
  var locale = typeof navigator !== 'undefined' && (navigator.language || navigator.userLanguage) || 'en-US';
  return {
    locale: locale,
    direction: $4cf919b2fb2672be$export$702d680b21cbd764(locale) ? 'rtl' : 'ltr'
  };
}

var $916d1fd2754d3f8c$var$currentLocale = $916d1fd2754d3f8c$export$f09106e7c6677ec5();
var $916d1fd2754d3f8c$var$listeners = new Set();

function $916d1fd2754d3f8c$var$updateLocale() {
  $916d1fd2754d3f8c$var$currentLocale = $916d1fd2754d3f8c$export$f09106e7c6677ec5();

  var _iterator = _createForOfIteratorHelper($916d1fd2754d3f8c$var$listeners),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var listener = _step.value;
      listener($916d1fd2754d3f8c$var$currentLocale);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
}

function $916d1fd2754d3f8c$export$188ec29ebc2bdc3a() {
  var isSSR = $5a023$useIsSSR();

  var _$5a023$useState = $5a023$useState($916d1fd2754d3f8c$var$currentLocale),
      _$5a023$useState2 = _slicedToArray(_$5a023$useState, 2),
      defaultLocale = _$5a023$useState2[0],
      setDefaultLocale = _$5a023$useState2[1];

  $5a023$useEffect(function () {
    if ($916d1fd2754d3f8c$var$listeners.size === 0) window.addEventListener('languagechange', $916d1fd2754d3f8c$var$updateLocale);
    $916d1fd2754d3f8c$var$listeners.add(setDefaultLocale);
    return function () {
      $916d1fd2754d3f8c$var$listeners.delete(setDefaultLocale);
      if ($916d1fd2754d3f8c$var$listeners.size === 0) window.removeEventListener('languagechange', $916d1fd2754d3f8c$var$updateLocale);
    };
  }, []); // We cannot determine the browser's language on the server, so default to
  // en-US. This will be updated after hydration on the client to the correct value.

  if (isSSR) return {
    locale: 'en-US',
    direction: 'ltr'
  };
  return defaultLocale;
}

var $21755e9e87423be2$var$I18nContext = /*#__PURE__*/$5a023$react.createContext(null);

function $21755e9e87423be2$export$a54013f0d02a8f82(props) {
  var locale = props.locale,
      children = props.children;
  var defaultLocale = $916d1fd2754d3f8c$export$188ec29ebc2bdc3a();
  var value = locale ? {
    locale: locale,
    direction: $4cf919b2fb2672be$export$702d680b21cbd764(locale) ? 'rtl' : 'ltr'
  } : defaultLocale;
  return /*#__PURE__*/$5a023$react.createElement($21755e9e87423be2$var$I18nContext.Provider, {
    value: value
  }, children);
}

function $21755e9e87423be2$export$43bb16f9c6d9e3f7() {
  var defaultLocale = $916d1fd2754d3f8c$export$188ec29ebc2bdc3a();
  var context = $5a023$useContext($21755e9e87423be2$var$I18nContext);
  return context || defaultLocale;
}

var $aa99f94f0729b94d$exports = {};
$parcel$export($aa99f94f0729b94d$exports, "useMessageFormatter", function () {
  return $aa99f94f0729b94d$export$ec23bf898b1eed85;
});
var $aa99f94f0729b94d$var$cache = new WeakMap();

function $aa99f94f0729b94d$var$getCachedDictionary(strings) {
  var dictionary = $aa99f94f0729b94d$var$cache.get(strings);

  if (!dictionary) {
    dictionary = new $5a023$MessageDictionary(strings);
    $aa99f94f0729b94d$var$cache.set(strings, dictionary);
  }

  return dictionary;
}

function $aa99f94f0729b94d$export$ec23bf898b1eed85(strings) {
  var _$21755e9e87423be2$ex = $21755e9e87423be2$export$43bb16f9c6d9e3f7(),
      locale = _$21755e9e87423be2$ex.locale;

  var dictionary = $5a023$useMemo(function () {
    return $aa99f94f0729b94d$var$getCachedDictionary(strings);
  }, [strings]);
  var formatter = $5a023$useMemo(function () {
    return new $5a023$MessageFormatter(locale, dictionary);
  }, [locale, dictionary]);
  return $5a023$useCallback(function (key, variables) {
    return formatter.format(key, variables);
  }, [formatter]);
}

var $59b9e23dbbc6badb$exports = {};
$parcel$export($59b9e23dbbc6badb$exports, "useDateFormatter", function () {
  return $59b9e23dbbc6badb$export$85fd5fdf27bacc79;
});

function $59b9e23dbbc6badb$export$85fd5fdf27bacc79(options) {
  // Reuse last options object if it is shallowly equal, which allows the useMemo result to also be reused.
  var lastOptions = $5a023$useRef(null);
  if (options && lastOptions.current && $59b9e23dbbc6badb$var$isEqual(options, lastOptions.current)) options = lastOptions.current;
  lastOptions.current = options;

  var _$21755e9e87423be2$ex2 = $21755e9e87423be2$export$43bb16f9c6d9e3f7(),
      locale = _$21755e9e87423be2$ex2.locale;

  return $5a023$useMemo(function () {
    return new $5a023$DateFormatter(locale, options);
  }, [locale, options]);
}

function $59b9e23dbbc6badb$var$isEqual(a, b) {
  if (a === b) return true;
  var aKeys = Object.keys(a);
  var bKeys = Object.keys(b);
  if (aKeys.length !== bKeys.length) return false;

  for (var _i = 0, _aKeys = aKeys; _i < _aKeys.length; _i++) {
    var key = _aKeys[_i];
    if (b[key] !== a[key]) return false;
  }

  return true;
}

var $aec6a20912b8a35e$exports = {};
$parcel$export($aec6a20912b8a35e$exports, "useNumberFormatter", function () {
  return $aec6a20912b8a35e$export$b7a616150fdb9f44;
});

function $aec6a20912b8a35e$export$b7a616150fdb9f44() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _$21755e9e87423be2$ex3 = $21755e9e87423be2$export$43bb16f9c6d9e3f7(),
      locale = _$21755e9e87423be2$ex3.locale;

  return $5a023$useMemo(function () {
    return new $5a023$NumberFormatter(locale, options);
  }, [locale, options]);
}

var $bc0d3f91da683b81$exports = {};
$parcel$export($bc0d3f91da683b81$exports, "useCollator", function () {
  return $bc0d3f91da683b81$export$a16aca283550c30d;
});
var $bc0d3f91da683b81$var$cache = new Map();

function $bc0d3f91da683b81$export$a16aca283550c30d(options) {
  var _$21755e9e87423be2$ex4 = $21755e9e87423be2$export$43bb16f9c6d9e3f7(),
      locale = _$21755e9e87423be2$ex4.locale;

  var cacheKey = locale + (options ? Object.entries(options).sort(function (a, b) {
    return a[0] < b[0] ? -1 : 1;
  }).join() : '');
  if ($bc0d3f91da683b81$var$cache.has(cacheKey)) return $bc0d3f91da683b81$var$cache.get(cacheKey);
  var formatter = new Intl.Collator(locale, options);
  $bc0d3f91da683b81$var$cache.set(cacheKey, formatter);
  return formatter;
}

var $4427549eda601635$exports = {};
$parcel$export($4427549eda601635$exports, "useFilter", function () {
  return $4427549eda601635$export$3274cf84b703fff;
});

function $4427549eda601635$export$3274cf84b703fff(options) {
  var collator = $bc0d3f91da683b81$export$a16aca283550c30d(_objectSpread({
    usage: 'search'
  }, options)); // TODO(later): these methods don't currently support the ignorePunctuation option.

  return {
    startsWith: function startsWith(string, substring) {
      if (substring.length === 0) return true; // Normalize both strings so we can slice safely
      // TODO: take into account the ignorePunctuation option as well...

      string = string.normalize('NFC');
      substring = substring.normalize('NFC');
      return collator.compare(string.slice(0, substring.length), substring) === 0;
    },
    endsWith: function endsWith(string, substring) {
      if (substring.length === 0) return true;
      string = string.normalize('NFC');
      substring = substring.normalize('NFC');
      return collator.compare(string.slice(-substring.length), substring) === 0;
    },
    contains: function contains(string, substring) {
      if (substring.length === 0) return true;
      string = string.normalize('NFC');
      substring = substring.normalize('NFC');
      var scan = 0;
      var sliceLen = substring.length;

      for (; scan + sliceLen <= string.length; scan++) {
        var slice = string.slice(scan, scan + sliceLen);
        if (collator.compare(substring, slice) === 0) return true;
      }

      return false;
    }
  };
}

export { $21755e9e87423be2$export$a54013f0d02a8f82 as I18nProvider, $21755e9e87423be2$export$43bb16f9c6d9e3f7 as useLocale, $aa99f94f0729b94d$export$ec23bf898b1eed85 as useMessageFormatter, $59b9e23dbbc6badb$export$85fd5fdf27bacc79 as useDateFormatter, $aec6a20912b8a35e$export$b7a616150fdb9f44 as useNumberFormatter, $bc0d3f91da683b81$export$a16aca283550c30d as useCollator, $4427549eda601635$export$3274cf84b703fff as useFilter };